<template>
  <div class="quiz columms">
    <section id="quizSection" class="column is-offset-3 is-6">
      <div v-for="question in questions" :key="question.id" :id="question.id">
        <form @submit.prevent="submitQuiz(question, eachSelectedOption)" :id="question.id">
          <div class="field">
            <label class="label is-font-sans is-color-pff-light-blue font-size-1-25">{{ question.question }}</label>
            <div
              class="control has-text-centered"
              v-for="option in question.options"
              :key="option.theOptionId"
            >
              <label class="radio is-color-white padding-0-5 radio-buttons-as-buttons">
                <label
                  class="button button-customization has-text-weight-bold is-color-pff-green font-size-1-25"
                  v-if="eachSelectedOption == option.theOption"
                >
                  <input
                    type="radio"
                    :name="question.question"
                    :value="option.theOption"
                    v-model="eachSelectedOption"
                    required
                  />
                  {{ option.theOption }}
                </label>
                <label
                  class="button has-text-weight-medium button-customization is-background-color-pff-green is-color-white font-size-1-25"
                  v-else
                >
                  <input
                    type="radio"
                    :name="question.question"
                    :value="option.theOption"
                    v-model="eachSelectedOption"
                    required
                  />
                  {{ option.theOption }}
                </label>
              </label>
            </div>
          </div>
          <br />
          <!-- <div class="field is-pulled-right"> -->
          <div class="field">
            <div class="control has-text-centered">
              <router-link to="/">
                <button
                  class="button is-font-sans font-size-1-25 is-outlined is-color-pff-orange"
                >Cancel</button>
              </router-link>
              <span id="spacing"></span>
              <button
                id="submitButton"
                class="button font-size-1-25 is-font-sans is-color-white is-background-color-pff-orange"
                v-if="question == questions[questions.length - 1]"
              >Show my personality!</button>
              <button
                class="button font-size-1-25 is-font-sans is-color-white is-background-color-pff-orange"
                v-else
              >Next question</button>
            </div>
          </div>
          <br />
        </form>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Quiz",
  data() {
    return {
      questions: this.$store.getters.getQuestions,
      lastQuestion: "",
      results: [],
      eachSelectedOption: ""
    };
  },
  beforeCreate() {},
  created() {
    if (this.questions.length == 0) {
      console.log("redirect");
      this.$router.push("/");
    }
  },
  methods: {
    submitQuiz(theQuestion, theOption) {
      var thisQuestionIndex = this.questions.indexOf(theQuestion);

      if (thisQuestionIndex == this.questions.length - 1) {
        document.getElementById("quizSection").style.visibility = "hidden";
      }

      // console.log("submitted " + theQuestion.question);

      let actualPersonality = "";

      theQuestion.options.forEach(optionObject => {
        if (optionObject.theOption == theOption) {
          actualPersonality = optionObject.thePersonality;
        }
      });

      this.results.push({
        question: theQuestion.question,
        option: theOption,
        personality: actualPersonality
      });

      if (thisQuestionIndex != this.questions.length - 1) {
        document.getElementById(
          this.questions[thisQuestionIndex].id
        ).style.display = "none";
        document.getElementById(
          this.questions[thisQuestionIndex + 1].id
        ).style.display = "inline";
      } else {
        this.$store.commit("setResult", this.results);
        this.$router.push("personality");
      }
      window.scrollTo(0, 0);
    }
  },
  mounted() {
    this.questions.forEach(question => {
      if (this.questions.indexOf(question) != 0) {
        document.getElementById(question.id).style.display = "none";
      }
    });
  }
};
</script>

<style scoped>
.button-customization {
  width: 40rem !important;
  white-space: normal;
  height: auto;
  border: #78a22f 2px solid;
  /* word-wrap:break-word; */
}

.quiz {
  text-align: center;
  /* padding-top: 5vh; */
}

#spacing {
  padding: 0.25rem;
}

.radio {
  padding: 0.5rem;
}

.padding-0-5 {
  padding: 0.5rem;
}

label {
  @extend button;
}

input {
  display: none;
}

@media only screen and (max-width: 600px) {
  .button-customization {
    width: 90vw !important;
    /* padding: 6rem .75rem; */
  }
}
</style>
